'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * @primitive RadioGroup / RadioGroupItem
 * ROLE: radiogroup + radio | ARIA: aria-checked, aria-disabled; group needs aria-label or aria-labelledby
 * KEYBOARD: ArrowUp/ArrowDown/ArrowLeft/ArrowRight navigate within group; Tab exits group
 * FOCUS: one tab stop per group (roving tabindex via Radix); selected item receives focus
 * LIVE-REGION: none (aria-checked change announced by AT)
 * PRM: selection indicator transition instant
 * FORCED-COLORS: ring = Highlight; dot = HighlightText
 * RTL: arrow-key navigation direction-aware via Radix; layout direction-agnostic
 * RSC: CLIENT
 * WAI-APG: https://www.w3.org/WAI/ARIA/apg/patterns/radio/
 * SUBSTRATE: @radix-ui/react-radio-group
 * NOTE: fieldset/legend semantics are the FORM-SYSTEM agent's concern via <Field as="fieldset">
 */
import * as RadixRadioGroup from '@radix-ui/react-radio-group';
import styles from './Radio.module.css';
export function RadioGroup({ value, onValueChange, disabled = false, orientation = 'vertical', children, ...ariaProps }) {
    return (_jsx(RadixRadioGroup.Root, { value: value, onValueChange: onValueChange, disabled: disabled, orientation: orientation, className: styles.group, ...ariaProps, children: children }));
}
export function RadioGroupItem({ value, disabled = false, children }) {
    return (_jsxs("label", { className: styles.wrapper, children: [_jsx(RadixRadioGroup.Item, { value: value, disabled: disabled, className: styles.radio, children: _jsx(RadixRadioGroup.Indicator, { className: styles.indicator }) }), _jsx("span", { className: styles.label, children: children })] }));
}
//# sourceMappingURL=Radio.js.map